module.exports = __webpack_public_path__ + "4589c3421f256666de235f82b91f8b50.fbx";